"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var color_1 = require("@seaweb/coral/utils/color");
var TextFieldContext_1 = require("./TextFieldContext");
var Fraction = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", "px;\n    padding: 0 ", "px;\n  "], ["\n    font-family: ", ";\n    font-size: ", "px;\n    padding: 0 ", "px;\n  "])), theme.typography.main, theme.typography.sizes.main, 2 * theme.spacing.factor);
});
var Count = styled_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var colors = _a.theme.colors;
    return styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n\n    &[data-coral-invalid] {\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n\n    &[data-coral-invalid] {\n      color: ", ";\n    }\n  "])), color_1.alp(colors.alternate, 0.75), colors.secondary);
});
var OutOf = styled_1.default.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), color_1.alp(theme.colors.alternate, 0.25));
});
var TextFieldCharCount = react_1.forwardRef(function TextFieldCharCount(_a, ref) {
    var as = _a.as, outOf = _a.outOf, props = __rest(_a, ["as", "outOf"]);
    var length = TextFieldContext_1.useTextFieldContext().value.length;
    var dataCoral = {};
    if (length > outOf) {
        dataCoral['data-coral-invalid'] = '';
    }
    return (react_1.default.createElement(Fraction, __assign({ as: as, ref: ref, "aria-label": "Input length " + length + " out of " + outOf }, props),
        react_1.default.createElement(Count, __assign({}, dataCoral), length),
        react_1.default.createElement(OutOf, null, "/" + outOf)));
});
exports.default = react_1.memo(TextFieldCharCount);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
